
import { resourceHeaders } from './resource-actions.factory';

/**
 * @typedef {object} IProviderAccountResource
 * @property {() => ng.resource.IResource<import('types/api').V2.FetchProviderAccounts.Response>} fetchAll
 *
 */

export default [
  '$resource',
  'unAuthedInterceptor',
  ProviderAccountResource,
];

/**
 * @param {ng.resource.IResourceService} $resource
 * @param {any} unAuthedInterceptor
 * @return {IProviderAccountResource}
 */
export function ProviderAccountResource($resource, unAuthedInterceptor) {
  // @ts-ignore
  return $resource(
    '/api/v2/provider-accounts',
    {},
    {
      'fetchAll': {
        method: 'GET',
        headers: resourceHeaders.get,
        interceptor: unAuthedInterceptor,
        timeout: 20000
      },
    },
  );
}